angular.module('mercury.modules.qa.bepoz', [
  'mercury.modules.qa.bepoz.periodsummary',
  'mercury.modules.qa.bepoz.productsummary',
  'mercury.modules.qa.bepoz.operatorsummary'
]);
